import React, {useEffect} from 'react';
import BundleOption from "@app/react/components/BundleWizard/BundleOption.jsx";
import Price from "@app/react/components/Price/Price.jsx";
import InvalidQtyMessage from "@app/react/components/InvalidQtyMessage/InvalidQtyMessage.jsx";
import Api from "@app/api/Api.js";
import './styles.scss';

export default function BundleCart({bundle, discount}) {
  const [cart, setCart] = React.useState({})
  let subtotal = 0
  let accessories_total = 0
  let hasInvalidQty = false

  bundle?.options.forEach(option => {
    option.productVariations.forEach(variation => {
      const qty = cart[option.id]?.[variation.id] ?? 0
      const p = qty * variation.price
      subtotal += p
      if(option.quantity === 0) {
        accessories_total += p
      }
      if(qty > 0 && (qty < variation.min_qty || qty % variation.mult_qty !== 0)) {
        hasInvalidQty = true
      }
    })
  })

  const d1 = discount?.d1 ?? 0
  const d2 = discount?.d2 ?? 0
  const d3 = discount?.d3 ?? 0
  const d4 = discount?.d4 ?? 0
  const hasDiscount = d1 > 0 || d2 > 0 || d3 > 0 || d4 > 0
  const discountFactor = hasDiscount
    ? 1 - (1 - d1 / 100) * (1 - d2 / 100) * (1 - d3 / 100) * (1 - d4 / 100)
    : 0
  const discountAmount = subtotal * discountFactor
  const total = subtotal - discountAmount

  const activeParts = [d1, d2, d3, d4].filter(d => d > 0)
  const discountLabel = activeParts.length > 1
    ? Drupal.tt('Sconto @parts%', null, null, {'@parts': activeParts.join('% + ')})
    : Drupal.tt('Sconto @d1%', null, null, {'@d1': activeParts[0] ?? d1})

  useEffect(() => {
    setCart({})
  }, [bundle]);

  function handleCartUpdate(optionId, variationId, qty) {
    setCart(prev => ({...prev, [optionId]: {...(prev[optionId] || {}), [variationId]: qty}}))
  }

  function handleAddToCart() {
    const cartItems = []
    for(const [optionId, variations] of Object.entries(cart)) {
      for(const [variationId, qty] of Object.entries(variations)) {
        cartItems.push({
          product_variation_id: parseInt(variationId),
          quantity: qty
        })
      }
    }

    Api.post('api/cart', {items: cartItems}).then(response => {
      window.location.href = Drupal.url('cart')
    })
  }

  return <div className='bundle-cart-wrapper h-100'>
    {!bundle && <div className='bundle-cart h-100'>
      <h2>{Drupal.tt("seleziona un bundle")}</h2>
      <p>{Drupal.tt("seleziona una combinazione di telaio, versione e stile per vedere i componenti associati")}</p>
    </div>}
    {bundle && <>
      <div className='bundle-cart'>
        <h2>{Drupal.tt("personalizza configurazione")}</h2>
        {bundle.description && <p className='bundle-description'>{bundle.description}</p>}
        {bundle.options.map(option => <BundleOption key={option.id} cart={cart} option={option} onChange={handleCartUpdate} />)}
      </div>
      <div className='bundle-cart-total'>
        {hasDiscount && subtotal > 0 && (
          <div className='subtotal'>
            <span className='label'>{Drupal.tt('Subtotale')}</span>
            <span className='price'><Price value={subtotal} /></span>
          </div>
        )}
        {hasDiscount && subtotal > 0 && (
          <div className='adjustment'>
            <span className='label'>{discountLabel}</span>
            <span className='price'><Price value={-discountAmount} /></span>
          </div>
        )}
        <div className='total'>
          <span className='label'>{Drupal.tt('Totale')}</span>
          <span className='price'><Price value={total} /></span>
        </div>
        {accessories_total > 0 && (
          <div className='subtotal'>
            <span className='label'>{Drupal.tt('di cui accessori')}</span>
            <span className='price'><Price value={accessories_total} /></span>
          </div>
        )}
        {hasInvalidQty && <InvalidQtyMessage />}
      </div>
      <div className='bundle-cart-actions'>
        <button onClick={handleAddToCart} className="btn btn-primary">{Drupal.tt("Aggiungi al carrello")}</button>
      </div>
    </>}

  </div>
}
